import { Interweave } from "interweave";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { getCategories } from "../services/categories.services";
import { formatDateMDDYYYY } from "../utils/Date.util";

const PostDetails = () => {
  const [categories, setCategories] = useState([]);
  const { state } = useLocation();
  const { postDetails } = state;

  useEffect(() => {
    console.log(postDetails);
  }, []);

  const fetchCategories = async () => {
    const categories = await getCategories();
    setCategories(categories);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <section className="th-blog-wrapper blog-details space-top space-extra-bottom">
      <div className="container">
        <div className="row">
          <div className="col-xxl-9 col-lg-8">
            <div className="th-blog blog-single">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                {postDetails.categories.map((category, index) => {
                  return (
                    <a
                      key={index}
                      data-theme-color="#4E4BD0"
                      href="blog.html"
                      className="category"
                    >
                      {category.name}
                    </a>
                  );
                })}
              </div>
              <h2 className="blog-title">{postDetails.title}</h2>
              <div className="blog-meta">
                <a className="author" href="blog.html">
                  <i className="far fa-user"></i>By - {postDetails.author.name}
                </a>
                <a href="blog.html">
                  <i className="fal fa-calendar-days"></i>{formatDateMDDYYYY(postDetails.created_at)}
                </a>
              </div>
              <div className="blog-img">
                <img
                  src={`${process.env.REACT_APP_REDLINES_IMAGE_STORAGE}/${postDetails.featured_image}`}
                  alt="Blog Image"
                />
              </div>
              <div className="blog-content-wrap">
                <div className="share-links-wrap">
                  <div className="share-links">
                    <span className="share-links-title">Share Post:</span>
                    <div className="multi-social">
                      <a href="https://facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="https://twitter.com/" target="_blank">
                        <i className="fab fa-twitter"></i>
                      </a>
                      <a href="https://linkedin.com/" target="_blank">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                      <a href="https://pinterest.com/" target="_blank">
                        <i className="fab fa-pinterest-p"></i>
                      </a>
                      <a href="https://instagram.com/" target="_blank">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="blog-content">
                  <div className="content">
                    <Interweave content={postDetails.body} />
                  </div>
                </div>
              </div>
            </div>
            <div className="blog-navigation">
              <div className="nav-btn prev">
                <div className="img">
                  <img
                    src="assets/img/blog/blog-nav-1.jpg"
                    alt="blog img"
                    className="nav-img"
                  />
                </div>
                <div className="media-body">
                  <h5 className="title">
                    <a className="hover-line" href="blog-details.html">
                      Game on! Embrace the spirit of sportsmanship
                    </a>
                  </h5>
                  <a href="blog-details.html" className="nav-text">
                    <i className="fas fa-arrow-left me-2"></i>Prev
                  </a>
                </div>
              </div>
              <div className="divider"></div>
              <div className="nav-btn next">
                <div className="media-body">
                  <h5 className="title">
                    <a className="hover-line" href="blog-details.html">
                      Push your limits, redefine what's possible
                    </a>
                  </h5>
                  <a href="blog-details.html" className="nav-text">
                    Next<i className="fas fa-arrow-right ms-2"></i>
                  </a>
                </div>
                <div className="img">
                  <img
                    src="assets/img/blog/blog-nav-2.jpg"
                    alt="blog img"
                    className="nav-img"
                  />
                </div>
              </div>
            </div>
            <div className="blog-author">
              <div className="auhtor-img">
                <img
                  src="assets/img/blog/blog-author.jpg"
                  alt="Blog Author Image"
                />
              </div>
              <div className="media-body">
                <div className="author-top">
                  <div>
                    <h3 className="author-name">
                      <a className="text-inherit" href="team-details.html">
                        Ronald Richards
                      </a>
                    </h3>
                    <span className="author-desig">Founder & CEO</span>
                  </div>
                  <div className="social-links">
                    <a href="https://facebook.com/" target="_blank">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://twitter.com/" target="_blank">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://linkedin.com/" target="_blank">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://instagram.com/" target="_blank">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <p className="author-text">
                  Adventurer and passionate travel blogger. With a backpack full
                  of stories and a camera in hand, she takes her readers on
                  exhilarating journeys around the world.
                </p>
              </div>
            </div>
            <div className="related-post-wrapper pt-30 mb-30">
              <div className="row align-items-center">
                <div className="col">
                  <h2 className="sec-title has-line">Related Post</h2>
                </div>
                <div className="col-auto">
                  <div className="sec-btn">
                    <div className="icon-box">
                      <button
                        data-slick-prev="#related-post-slide"
                        className="slick-arrow default"
                      >
                        <i className="far fa-arrow-left"></i>
                      </button>
                      <button
                        data-slick-next="#related-post-slide"
                        className="slick-arrow default"
                      >
                        <i className="far fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row slider-shadow th-carousel"
                id="related-post-slide"
                data-slide-show="3"
                data-lg-slide-show="2"
                data-md-slide-show="2"
                data-sm-slide-show="2"
              >
                <div className="col-sm-6 col-xl-4">
                  <div className="blog-style1">
                    <div className="blog-img">
                      <img
                        src="assets/img/blog/blog_1_1.jpg"
                        alt="blog image"
                      />
                      <a
                        data-theme-color="#00D084"
                        href="blog.html"
                        className="category"
                      >
                        Lifestyle
                      </a>
                    </div>
                    <h3 className="box-title-22">
                      <a className="hover-line" href="blog-details.html">
                        Balance harmony and joy in Every lifestyle.
                      </a>
                    </h3>
                    <div className="blog-meta">
                      <a href="author.html">
                        <i className="far fa-user"></i>By - Tnews
                      </a>
                      <a href="blog.html">
                        <i className="fal fa-calendar-days"></i>15 Mar, 2023
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-xl-4">
                  <div className="blog-style1">
                    <div className="blog-img">
                      <img
                        src="assets/img/blog/blog_1_2.jpg"
                        alt="blog image"
                      />
                      <a
                        data-theme-color="#FF9500"
                        href="blog.html"
                        className="category"
                      >
                        Politics
                      </a>
                    </div>
                    <h3 className="box-title-22">
                      <a className="hover-line" href="blog-details.html">
                        Power to the people for a Better future!
                      </a>
                    </h3>
                    <div className="blog-meta">
                      <a href="author.html">
                        <i className="far fa-user"></i>By - Tnews
                      </a>
                      <a href="blog.html">
                        <i className="fal fa-calendar-days"></i>16 Mar, 2023
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-xl-4">
                  <div className="blog-style1">
                    <div className="blog-img">
                      <img
                        src="assets/img/blog/blog_1_3.jpg"
                        alt="blog image"
                      />
                      <a
                        data-theme-color="#E7473C"
                        href="blog.html"
                        className="category"
                      >
                        Fitness
                      </a>
                    </div>
                    <h3 className="box-title-22">
                      <a className="hover-line" href="blog-details.html">
                        Fitness the key to vitality and Well-being.
                      </a>
                    </h3>
                    <div className="blog-meta">
                      <a href="author.html">
                        <i className="far fa-user"></i>By - Tnews
                      </a>
                      <a href="blog.html">
                        <i className="fal fa-calendar-days"></i>21 Mar, 2023
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-xl-4">
                  <div className="blog-style1">
                    <div className="blog-img">
                      <img
                        src="assets/img/blog/blog_1_4.jpg"
                        alt="blog image"
                      />
                      <a
                        data-theme-color="#00D084"
                        href="blog.html"
                        className="category"
                      >
                        Health
                      </a>
                    </div>
                    <h3 className="box-title-22">
                      <a className="hover-line" href="blog-details.html">
                        Embrace bump and Victory volleyball style.
                      </a>
                    </h3>
                    <div className="blog-meta">
                      <a href="author.html">
                        <i className="far fa-user"></i>By - Tnews
                      </a>
                      <a href="blog.html">
                        <i className="fal fa-calendar-days"></i>14 Mar, 2023
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-3 col-lg-4 sidebar-wrap">
            <aside className="sidebar-area">
              <div className="widget widget_search  ">
                <form className="search-form">
                  <input type="text" placeholder="Enter Keyword" />
                  <button type="submit">
                    <i className="far fa-search"></i>
                  </button>
                </form>
              </div>
              <div className="widget widget_categories  ">
                <h3 className="widget_title">Categories</h3>
                <ul>
                  {categories.map((category, index) => {
                    return (
                      <li key={index}>
                        <NavLink
                          to={`../../category/${category.name}`}
                          state={{ name: category.name }}
                        >
                          {category.name}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="widget  ">
                <h3 className="widget_title">Recent Posts</h3>
                <div className="recent-post-wrap">
                  <div className="recent-post">
                    <div className="media-img">
                      <a href="blog-details.html">
                        <img
                          src="assets/img/blog/recent-post-1-1.jpg"
                          alt="Blog Image"
                        />
                      </a>
                    </div>
                    <div className="media-body">
                      <h4 className="post-title">
                        <a className="hover-line" href="blog-details.html">
                          Fitness: Your journey to Better, stronger you.
                        </a>
                      </h4>
                      <div className="recent-post-meta">
                        <a href="blog.html">
                          <i className="fal fa-calendar-days"></i>21 June, 2023
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="recent-post">
                    <div className="media-img">
                      <a href="blog-details.html">
                        <img
                          src="assets/img/blog/recent-post-1-2.jpg"
                          alt="Blog Image"
                        />
                      </a>
                    </div>
                    <div className="media-body">
                      <h4 className="post-title">
                        <a className="hover-line" href="blog-details.html">
                          Embrace the game Ignite your sporting
                        </a>
                      </h4>
                      <div className="recent-post-meta">
                        <a href="blog.html">
                          <i className="fal fa-calendar-days"></i>22 June, 2023
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="recent-post">
                    <div className="media-img">
                      <a href="blog-details.html">
                        <img
                          src="assets/img/blog/recent-post-1-3.jpg"
                          alt="Blog Image"
                        />
                      </a>
                    </div>
                    <div className="media-body">
                      <h4 className="post-title">
                        <a className="hover-line" href="blog-details.html">
                          Revolutionizing lives Through technology
                        </a>
                      </h4>
                      <div className="recent-post-meta">
                        <a href="blog.html">
                          <i className="fal fa-calendar-days"></i>23 June, 2023
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="recent-post">
                    <div className="media-img">
                      <a href="blog-details.html">
                        <img
                          src="assets/img/blog/recent-post-1-4.jpg"
                          alt="Blog Image"
                        />
                      </a>
                    </div>
                    <div className="media-body">
                      <h4 className="post-title">
                        <a className="hover-line" href="blog-details.html">
                          Enjoy the Virtual Reality embrace the
                        </a>
                      </h4>
                      <div className="recent-post-meta">
                        <a href="blog.html">
                          <i className="fal fa-calendar-days"></i>25 June, 2023
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="widget  ">
                <div className="widget-ads">
                  <a href="https://themeforest.net/user/themeholy/portfolio">
                    <img
                      className="w-100"
                      src="assets/img/ads/siderbar_ads_1.jpg"
                      alt="ads"
                    />
                  </a>
                </div>
              </div>
              <div className="widget widget_tag_cloud  ">
                <h3 className="widget_title">Popular Tags</h3>
                <div className="tagcloud">
                  <a href="blog.html">Sports</a>
                  <a href="blog.html">Politics</a>
                  <a href="blog.html">Business</a>
                  <a href="blog.html">Music</a>
                  <a href="blog.html">Food</a>
                  <a href="blog.html">Technology</a>
                  <a href="blog.html">Travels</a>
                  <a href="blog.html">Health</a>
                  <a href="blog.html">Fashions</a>
                  <a href="blog.html">Animal</a>
                  <a href="blog.html">Weather</a>
                  <a href="blog.html">Movies</a>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PostDetails;
